import React from "react";
import styled from "styled-components";
import { FlexboxProps, WidthProps } from "styled-system";
import { FlexVertical } from "../Flex";
import { VectorFooterSectionTitle } from "../VectorFooterSectionTitle";

interface Props {
  title: React.ReactNode;
  children?: React.ReactNode;
  titleMb?: number;
}

const SectionTitle = styled(props => <VectorFooterSectionTitle {...props} fontSize={14} />)`
  line-height: 22px;
  margin-top: 0;
`;

const UL = styled.ul`
  list-style: none;
  padding-inline-start: 0px;
  padding: 0px;
  margin: 0;
`;

const LI = styled.li`
  line-height: 15px;
  margin-bottom: 6px;
  > a {
    font-size: 14px;
    line-height: 15px;
    font-weight: 400;
  }
`;

export const ServiceCatalogueFooterSection: React.FC<Props & FlexboxProps & WidthProps> = ({
  title,
  width,
  titleMb,
  children,
  ...restProps
}) => (
  <FlexVertical width={width} px="15px" mb={[3, 0]} {...restProps}>
    <SectionTitle value={title} mb={titleMb} />
    <UL>
      {React.Children.map(children, child => (
        <LI>{child}</LI>
      ))}
    </UL>
  </FlexVertical>
);

ServiceCatalogueFooterSection.defaultProps = {
  width: [1 / 2, 1 / 2, "18%", "18%"],
  titleMb: 3,
};
